/* eslint-disable */
export enum VehicleEnum {
  TRUCK = 'TRUCK',
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE',
  BIKE = 'BIKE',
  WALKER = 'WALKER',
}

export enum VehicleStatus {
  AVAILABLE = 'AVAILABLE',
  ASSIGNED = 'ASSIGNED',
  IN_TRANSIT = 'IN_TRANSIT',
  MAINTENANCE = 'MAINTENANCE',
  UNAVAILABLE = 'UNAVAILABLE',
}
